module.exports = "/images/gif-fileicon.svg?03060db02688c3df7b6b51a657b8ad1e";